<div class="flex max-w-5xl flex-col gap-4">
  @if (error()) {
    <div
      class="flex items-center gap-2 rounded-lg border border-error-200 bg-error-50 p-4 text-paragraph-s-reg text-error-700"
    >
      <lucide-icon name="triangle-alert" [size]="18" />
      {{ "help.onboarding.journey.loadError" | transloco }}
    </div>
  }

  @if (journey()) {
    <!-- Where you stand: ring, level, both tracks and the milestone path -->
    <app-journey-header (phaseSelected)="onPhaseSelected($event)" />

    <!-- The one thing to do next -->
    <app-journey-next-step />

    <!-- The five phases, collapsed around the one in progress -->
    <div class="flex flex-col gap-3">
      @for (phase of phases(); track phase.phase) {
        <app-journey-phase-card
          [phase]="phase"
          [expanded]="expandedPhase() === phase.phase"
          [pendingStepKey]="pendingStepKey()"
          (expandToggled)="togglePhase(phase.phase)"
          (stepToggled)="onStepToggled($event)"
        />
      }
    </div>
  } @else if (isLoading()) {
    <div class="rounded-lg border border-gray-200 bg-white p-8 text-center">
      <span class="text-paragraph-reg text-greyscale-600">
        {{ "help.onboarding.journey.loading" | transloco }}
      </span>
    </div>
  }
</div>
